import React from 'react';
import { Row, Col, Card } from 'reactstrap';
import CodeBlock from '../CodeBlock';

function DictionarySection() {
    return (
        <section id="dictionary">
            <Row>
                <Col>
                    <h3>Dictionary endpoint (/Dictionary) – allowed values in search criteria</h3>
                    <p>
                        <code>GET</code> request to the following endpoints do not require authentication.
                    </p>
                    <p>
                        <ul className="list-group">
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/CareerStructureSectors</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/CatererEmployerTypes</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/CatererJobTypes</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/Countries</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/EducationLevel</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/TotalJobsIndustrySectors</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/JobHours</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/CareerStructureJobRoles</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/JobTypes</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/Languages</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/CatererPositions</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/SalaryRateType</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/DesiredLocations</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/SortColumns</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/SearchableLocations</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/HideCandidatesViewed</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/JobTitleType</code>
                            </li>
                            <li className="list-group-item border-0 p-0">
                                <code>/Dictionary/CvProfileType</code>
                            </li>
                        </ul>
                    </p>
                    <p>
                        If <code>content-type</code> is not specified as <code>application/json; charset=utf-8</code>{' '}
                        <code>application/xml; charset=utf-8</code> will be returned.
                    </p>
                    <Card className="bg-dark text-white" body>
                        <h4>Curl Example</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`curl -X GET \\\n'https://recruiter.totaljobs.com/CandidateSearchApi/Dictionary/DesiredLocations'\\\n-H 'cache-control: no-cache'`}
                        </CodeBlock>
                        <h4>REQUEST HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`content-type: application/json; charset=utf-8`}
                        </CodeBlock>
                        <h4>RESPONSE HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`content-type: application/json; charset=utf-8\nstatus: 200 OK`}
                        </CodeBlock>
                        <h4>RESPONSE BODY</h4>
                        <CodeBlock langauge="json" theme="dark">
                            {`[\n\t{\n\t\t"Name": "East Anglia",\n\t\t"ChildLocations": [\n\t\t\t"Cambridgeshire",\n\t\t\t"Norfolk",\n\t\t\t"Suffolk"\n\t\t]\n\t},…\n]`}
                        </CodeBlock>
                    </Card>
                </Col>
            </Row>
        </section>
    )
}

export default DictionarySection
